import DBFunctions from '@/common/DBFunctions.js';
//import Utils from '@/common/utils.js'
//import EHRFeatures from '@/services/ehrfeatures.service'
import LocalStorage from '@/services/storage.service';
import UserTplService from '@/services/users.tpl.service';
import UsersService from '../services/users.service';

export default {
    mixins: [DBFunctions],
    data() {
        return {
            isUseAsam: false
            //EHRReadOnlyList: []
        };
    },
    methods: {
        async setPermissions() {
            this.isUseAsam = await this.getUseASAM();
            this.setAllReadOnly(false);
            this.setAllPermissions(true);
            await UsersService.getUserByCode(LocalStorage.getUserId())
                .then(async response => {
                    if (response.data && response.data.length > 0) {
                        const user = response.data[0];
                        await this.setPermissionsByUserRol(user.userRoleCode);
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async setPermissionsByUserRol(roleId) {
            await UserTplService.getEHRFeatures(roleId)
                .then(response => {
                    if (response.data) {
                        const arr = response.data;

                        //Permissions
                        this.$store.commit(
                            'setUsePreScreening',
                            this.getEHRFeaturePermission(arr, 'PRESCREENING')
                        );
                        this.$store.commit(
                            'setUsePatientLabels',
                            this.getEHRFeaturePermission(arr, 'PATIENTLABELS')
                        );
                        this.$store.commit(
                            'setUseLetters',
                            this.getEHRFeaturePermission(arr, 'FORMGEN')
                        );
                        this.$store.commit('setUseMars', this.getEHRFeaturePermission(arr, 'MARS'));
                        this.$store.commit(
                            'setUseDrugInboxFill',
                            this.getEHRFeaturePermission(arr, 'DIFILL')
                        );
                        this.$store.commit(
                            'setUseDrugInboxAllergies',
                            this.getEHRFeaturePermission(arr, 'DIALLERGIES')
                        );
                        this.$store.commit(
                            'setUseDrugInboxInteraction',
                            this.getEHRFeaturePermission(arr, 'DIINTERACTION')
                        );

                        this.$store.commit(
                            'setUseDrugInboxFormularyStatus',
                            this.getEHRFeaturePermission(arr, 'FORMULARYSTATUS')
                        );
                        this.$store.commit(
                            'setUseDrugInboxPatientSignature',
                            this.getEHRFeaturePermission(arr, 'DIPATSIGNATURE')
                        );
                        this.$store.commit(
                            'setUseDrugInboxUndoPatientSignature',
                            this.getEHRFeaturePermission(arr, 'DIPATUNDOSIG')
                        );
                        this.$store.commit(
                            'setUseDrugInboxDrugInfo',
                            this.getEHRFeaturePermission(arr, 'DIDRUGINFO')
                        );
                        this.$store.commit(
                            'setUseDrugInboxPatientInfo',
                            this.getEHRFeaturePermission(arr, 'DIPATINFO')
                        );
                        this.$store.commit(
                            'setUseDrugInboxPharmacyNotes',
                            this.getEHRFeaturePermission(arr, 'DINOTES')
                        );
                        this.$store.commit(
                            'setUseDrugInboxPrescription',
                            this.getEHRFeaturePermission(arr, 'DIPRESCRIPTION')
                        );
                        this.$store.commit(
                            'setUseDrugInboxPrintMedLabel',
                            this.getEHRFeaturePermission(arr, 'DIPRINTLABEL')
                        );
                        this.$store.commit(
                            'setUseDrugInboxPrintMedicationHistory',
                            this.getEHRFeaturePermission(arr, 'DIMEDHISTORY')
                        );
                        this.$store.commit(
                            'setUseDrugInboxReturnedItems',
                            this.getEHRFeaturePermission(arr, 'DIRETURNEDITEMS')
                        );
                        this.$store.commit(
                            'setUseDrugInboxSetToChargeable',
                            this.getEHRFeaturePermission(arr, 'DICHARGEABLE')
                        );
                        this.$store.commit(
                            'setUseDrugInboxSetToPending',
                            this.getEHRFeaturePermission(arr, 'DIPENDING')
                        );
                        this.$store.commit(
                            'setUseDrugInboxSetToUnableToFill',
                            this.getEHRFeaturePermission(arr, 'DIUNABLETOFILL')
                        );
                        this.$store.commit(
                            'setUseDrugInboxSetToValid',
                            this.getEHRFeaturePermission(arr, 'DIVALID')
                        );
                        this.$store.commit(
                            'setUseDrugInboxUndoFillOrder',
                            this.getEHRFeaturePermission(arr, 'DIUNDOFILL')
                        );
                        this.$store.commit(
                            'setUseDrugInboxUndoSetToChargeable',
                            this.getEHRFeaturePermission(arr, 'DIUNDOCHARGEABLE')
                        );
                        this.$store.commit(
                            'setUseDrugInboxUndoSetToPending',
                            this.getEHRFeaturePermission(arr, 'DIORDER')
                        );
                        this.$store.commit(
                            'setUseDrugInboxUndoValidated',
                            this.getEHRFeaturePermission(arr, 'DIUNDOVALID')
                        );
                        this.$store.commit(
                            'setUsePatientAdmission',
                            this.getEHRFeaturePermission(arr, 'ADMISSION')
                        );
                        this.$store.commit(
                            'setUseTransfer',
                            this.getEHRFeaturePermission(arr, 'PROGTRANSFER')
                        );
                        this.$store.commit(
                            'setUseMedications',
                            this.getEHRFeaturePermission(arr, 'MEDICATIONS')
                        );
                        this.$store.commit(
                            'setDailyNotes',
                            this.getEHRFeaturePermission(arr, 'DAILY NOTES')
                        );
                        this.$store.commit(
                            'setLogNotes',
                            this.getEHRFeaturePermission(arr, 'LOGNOTES')
                        );
                        this.$store.commit(
                            'setUsePatientDiagnosis',
                            this.getEHRFeaturePermission(arr, 'PATIENTDIAGNOSIS')
                        );
                        this.$store.commit(
                            'setUseDischarge',
                            this.getEHRFeaturePermission(arr, 'PATDISCHARGE')
                        );
                        this.$store.commit(
                            'setUsePatientInfo',
                            this.getEHRFeaturePermission(arr, 'PATIENTINFO')
                        );
                        this.$store.commit(
                            'setUsePatientInsurance',
                            this.getEHRFeaturePermission(arr, 'PATIENTINSURANCE')
                        );
                        this.$store.commit(
                            'setUsePatientContact',
                            this.getEHRFeaturePermission(arr, 'PATIENTCONTACTS')
                        );
                        this.$store.commit(
                            'setUseASAM',
                            this.getEHRFeaturePermission(arr, 'ASAM') && this.isUseAsam
                        );
                        this.$store.commit(
                            'setUseClinicalNotes',
                            this.getEHRFeaturePermission(arr, 'CLINICAL_NOTESUS')
                        );
                        this.$store.commit(
                            'setUseVitalSign',
                            this.getEHRFeaturePermission(arr, 'VITAlSIGNS')
                        );
                        this.$store.commit(
                            'setUsePatientAllergies',
                            this.getEHRFeaturePermission(arr, 'PATIENTALLERGIES')
                        );
                        this.$store.commit(
                            'setUsePatientSpecialPr',
                            this.getEHRFeaturePermission(arr, 'PATIENTSPECIALPR')
                        );
                        this.$store.commit(
                            'setUsePatientMarsAlert',
                            this.getEHRFeaturePermission(arr, 'PATIENTMARALERT')
                        );
                        this.$store.commit(
                            'setUseChartReview',
                            this.getEHRFeaturePermission(arr, 'CHART')
                        );
                        this.$store.commit(
                            'setUsePatientDocument',
                            this.getEHRFeaturePermission(arr, 'PATIENTDOCUMENTS')
                        );
                        this.$store.commit(
                            'setUseEPharmacyNewCrop',
                            this.getEHRFeaturePermission(arr, 'NEWCROP')
                        );
                        this.$store.commit(
                            'setCompleteDraft',
                            this.getEHRFeaturePermission(arr, 'COMPLETEDRAFT')
                        );
                        this.$store.commit(
                            'setSchedulerClinical',
                            this.getEHRFeaturePermission(arr, 'SCHED_CLINICAL')
                        );
                        this.$store.commit(
                            'setAppointments',
                            this.getEHRFeaturePermission(arr, 'APPOINTMENTS')
                        );
                        this.$store.commit(
                            'setTreatmentPlanClinical',
                            this.getEHRFeaturePermission(arr, 'TREATMENTPLAN')
                        );
                        this.$store.commit(
                            'setUsePatientAlerts',
                            this.getEHRFeaturePermission(arr, 'ALERTS')
                        );
                        this.$store.commit(
                            'setUsePatientActivities',
                            this.getEHRFeaturePermission(arr, 'NOTES')
                        );
                        this.$store.commit(
                            'setUsePatientClaims',
                            this.getEHRFeaturePermission(arr, 'PATIENTCLAIMS')
                        );
                        this.$store.commit(
                            'SetPhysiciansOrder',
                            this.getEHRFeaturePermission(arr, 'ORDERS')
                        );
                        this.$store.commit(
                            'setUseTestResult',
                            this.getEHRFeaturePermission(arr, 'TESTRESULTS')
                        );
                        this.$store.commit('setUseLab', this.getEHRFeaturePermission(arr, 'ELAB'));
                        this.$store.commit(
                            'setTestOrders',
                            this.getEHRFeaturePermission(arr, 'LABORDERS')
                        );
                        this.$store.commit(
                            'setTestResults',
                            this.getEHRFeaturePermission(arr, 'TESTRESULTS')
                        );

                        this.$store.commit(
                            'setPatientPortalMessage',
                            this.getEHRFeaturePermission(arr, 'PPMESSAGES')
                        );
                        this.$store.commit(
                            'setPatientPortalContacts',
                            this.getEHRFeaturePermission(arr, 'PPCONTACTS')
                        );
                        this.$store.commit(
                            'setPatientPortalClaims',
                            this.getEHRFeaturePermission(arr, 'PPCLAIMS')
                        );
                        this.$store.commit(
                            'setPatientPortalChangeInformation',
                            this.getEHRFeaturePermission(arr, 'PPCHANGEPI')
                        );
                        this.$store.commit(
                            'setPatientPortalChangePassword',
                            this.getEHRFeaturePermission(arr, 'PPCHANGEPWD')
                        );
                        this.$store.commit(
                            'setPatientPortalChangeUsername',
                            this.getEHRFeaturePermission(arr, 'PPCHANGEUSR')
                        );
                        this.$store.commit(
                            'setPatientPortalCreateCredentials',
                            this.getEHRFeaturePermission(arr, 'PPCREATECRED')
                        );
                        this.$store.commit(
                            'setPatientPortalEmailTo',
                            this.getEHRFeaturePermission(arr, 'PPEMAILPAT')
                        );
                        this.$store.commit(
                            'setPatientPortalTextTo',
                            this.getEHRFeaturePermission(arr, 'PPTEXTPAT')
                        );
                        this.$store.commit(
                            'setPatientPortalForms',
                            this.getEHRFeaturePermission(arr, 'PPFORMS')
                        );
                        this.$store.commit(
                            'setPatientPortalPrintLetter',
                            this.getEHRFeaturePermission(arr, 'PPLETTER')
                        );

                        //ReadOnly
                        this.$store.commit(
                            'setLettersEHRReadOnly',
                            this.isNoteReadOnly(arr, 'FORMGEN')
                        );
                        this.$store.commit(
                            'setDrugInboxFillEHRReadOnly',
                            this.isNoteReadOnly(arr, 'DIFILL')
                        );
                        this.$store.commit(
                            'setDrugInboxAllergiesEHRReadOnly',
                            this.isNoteReadOnly(arr, 'DIALLERGIES')
                        );
                        this.$store.commit(
                            'setDrugInboxFormularyStatusEHRReadOnly',
                            this.isNoteReadOnly(arr, 'FORMULARYSTATUS')
                        );
                        this.$store.commit(
                            'setDrugInboxDrugInfoEHRReadOnly',
                            this.isNoteReadOnly(arr, 'DIDRUGINFO')
                        );
                        this.$store.commit(
                            'setDrugInboxPatientInfoEHRReadOnly',
                            this.isNoteReadOnly(arr, 'DIPATINFO')
                        );
                        this.$store.commit(
                            'setDrugInboxPharmacyNotesEHRReadOnly',
                            this.isNoteReadOnly(arr, 'DINOTES')
                        );
                        this.$store.commit(
                            'setDrugInboxPrescriptionEHRReadOnly',
                            this.isNoteReadOnly(arr, 'DIPRESCRIPTION')
                        );
                        this.$store.commit(
                            'setDrugInboxPrintMedLabelEHRReadOnly',
                            this.isNoteReadOnly(arr, 'DIPRINTLABEL')
                        );
                        this.$store.commit(
                            'setDrugInboxPrintMedicationHistoryEHRReadOnly',
                            this.isNoteReadOnly(arr, 'DIMEDHISTORY')
                        );
                        this.$store.commit(
                            'setDrugInboxReturnedItemsEHRReadOnly',
                            this.isNoteReadOnly(arr, 'DIRETURNEDITEMS')
                        );
                        this.$store.commit(
                            'setDrugInboxSetToChargeableEHRReadOnly',
                            this.isNoteReadOnly(arr, 'DICHARGEABLE')
                        );
                        this.$store.commit(
                            'setDrugInboxSetToPendingEHRReadOnly',
                            this.isNoteReadOnly(arr, 'DIPENDING')
                        );
                        this.$store.commit(
                            'setDrugInboxSetToUnableToFillEHRReadOnly',
                            this.isNoteReadOnly(arr, 'DIUNABLETOFILL')
                        );
                        this.$store.commit(
                            'setDrugInboxSetToValidEHRReadOnly',
                            this.isNoteReadOnly(arr, 'DIVALID')
                        );
                        this.$store.commit(
                            'setDrugInboxUndoFillOrderEHRReadOnly',
                            this.isNoteReadOnly(arr, 'DIUNDOFILL')
                        );
                        this.$store.commit(
                            'setDrugInboxUndoSetToChargeableEHRReadOnly',
                            this.isNoteReadOnly(arr, 'DIUNDOCHARGEABLE')
                        );
                        this.$store.commit(
                            'setDrugInboxUndoSetToPendingEHRReadOnly',
                            this.isNoteReadOnly(arr, 'DIORDER')
                        );
                        this.$store.commit(
                            'setDrugInboxUndoValidatedEHRReadOnly',
                            this.isNoteReadOnly(arr, 'DIUNDOVALID')
                        );
                        this.$store.commit('setASAMEHRReadOnly', this.isNoteReadOnly(arr, 'ASAM'));
                        this.$store.commit(
                            'setPatientInfoEHRReadOnly',
                            this.isNoteReadOnly(arr, 'PATIENTINFO')
                        );
                        this.$store.commit(
                            'setPatientInsuranceEHRReadOnly',
                            this.isNoteReadOnly(arr, 'PATIENTINSURANCE')
                        );
                        this.$store.commit(
                            'setPatientContactsEHRReadOnly',
                            this.isNoteReadOnly(arr, 'PATIENTCONTACTS')
                        );
                        this.$store.commit(
                            'setClinicalNotesEHRReadOnly',
                            this.isNoteReadOnly(arr, 'CLINICAL_NOTESUS')
                        );
                        this.$store.commit(
                            'setVitalSignEHRReadOnly',
                            this.isNoteReadOnly(arr, 'VITAlSIGNS')
                        );
                        this.$store.commit(
                            'setPatientAllergiesEHRReadOnly',
                            this.isNoteReadOnly(arr, 'PATIENTALLERGIES')
                        );
                        this.$store.commit(
                            'setPatientSpecialPrEHRReadOnly',
                            this.isNoteReadOnly(arr, 'PATIENTSPECIALPR')
                        );
                        this.$store.commit(
                            'setPatientMarsAlertEHRReadOnly',
                            this.isNoteReadOnly(arr, 'PATIENTMARALERT')
                        );
                        this.$store.commit(
                            'setPatientAdmissionEHRReadOnly',
                            this.isNoteReadOnly(arr, 'ADMISSION')
                        );
                        this.$store.commit(
                            'setClinicalTransferEHRReadOnly',
                            this.isNoteReadOnly(arr, 'PROGTRANSFER')
                        );
                        this.$store.commit(
                            'setClinicalMedicationsEHRReadOnly',
                            this.isNoteReadOnly(arr, 'MEDICATIONS')
                        );
                        this.$store.commit(
                            'setClinicalDischargeEHRReadOnly',
                            this.isNoteReadOnly(arr, 'PATDISCHARGE')
                        );
                        this.$store.commit(
                            'setPatientDiagnosisEHRReadOnly',
                            this.isNoteReadOnly(arr, 'PATIENTDIAGNOSIS')
                        );
                        this.$store.commit(
                            'setDailyNotesEHRReadOnly',
                            this.isNoteReadOnly(arr, 'DAILY NOTES')
                        );
                        this.$store.commit(
                            'setPatientDocumentEHRReadOnly',
                            this.isNoteReadOnly(arr, 'PATIENTDOCUMENTS')
                        );
                        this.$store.commit(
                            'setLogNotesEHRReadOnly',
                            this.isNoteReadOnly(arr, 'LOGNOTES')
                        );
                        this.$store.commit(
                            'setSchedulerClinicalEHRReadOnly',
                            this.isNoteReadOnly(arr, 'SCHED_CLINICAL')
                        );
                        this.$store.commit(
                            'setAppointmentsEHRReadOnly',
                            this.isNoteReadOnly(arr, 'APPOINTMENTS')
                        );
                        this.$store.commit(
                            'setTreatmentPlanEHRReadOnly',
                            this.isNoteReadOnly(arr, 'TREATMENTPLAN')
                        );
                        this.$store.commit(
                            'setEPrescribingEHRReadOnly',
                            this.isNoteReadOnly(arr, 'NEWCROP')
                        );
                        this.$store.commit('setMarsEHRReadOnly', this.isNoteReadOnly(arr, 'MARS'));
                        this.$store.commit('setTarsEHRReadOnly', this.isNoteReadOnly(arr, 'TARS'));
                        this.$store.commit(
                            'setPatientAlertsEHRReadOnly',
                            this.isNoteReadOnly(arr, 'ALERTS')
                        );
                        this.$store.commit(
                            'setPatientActivitiesEHRReadOnly',
                            this.isNoteReadOnly(arr, 'NOTES')
                        );
                        this.$store.commit(
                            'setPatientClaimsEHRReadOnly',
                            this.isNoteReadOnly(arr, 'PATIENTCLAIMS')
                        );
                        this.$store.commit(
                            'setPhysiciansOrderEHRReadOnly',
                            this.isNoteReadOnly(arr, 'ORDERS')
                        );
                        this.$store.commit(
                            'setTestOrdersEHRReadOnly',
                            this.isNoteReadOnly(arr, 'LABORDERS')
                        );
                        this.$store.commit(
                            'setTestResultsEHRReadOnly',
                            this.isNoteReadOnly(arr, 'TESTRESULTS')
                        );

                        this.$store.commit(
                            'setPatientPortalMessageEHRReadOnly',
                            this.isNoteReadOnly(arr, 'PPMESSAGES')
                        );
                        this.$store.commit(
                            'setPatientPortalContactsEHRReadOnly',
                            this.isNoteReadOnly(arr, 'PPCONTACTS')
                        );
                        this.$store.commit(
                            'setPatientPortalClaimsEHRReadOnly',
                            this.isNoteReadOnly(arr, 'PPCLAIMS')
                        );
                        this.$store.commit(
                            'setPatientPortalChangeInformationEHRReadOnly',
                            this.isNoteReadOnly(arr, 'PPCHANGEPI')
                        );
                        this.$store.commit(
                            'setPatientPortalChangePasswordEHRReadOnly',
                            this.isNoteReadOnly(arr, 'PPCHANGEPWD')
                        );
                        this.$store.commit(
                            'setPatientPortalChangeUsernameEHRReadOnly',
                            this.isNoteReadOnly(arr, 'PPCHANGEUSR')
                        );
                        this.$store.commit(
                            'setPatientPortalCreateCredentialsEHRReadOnly',
                            this.isNoteReadOnly(arr, 'PPCREATECRED')
                        );
                        this.$store.commit(
                            'setPatientPortalEmailToEHRReadOnly',
                            this.isNoteReadOnly(arr, 'PPEMAILPAT')
                        );
                        this.$store.commit(
                            'setPatientPortalTextToEHRReadOnly',
                            this.isNoteReadOnly(arr, 'PPTEXTPAT')
                        );
                        this.$store.commit(
                            'setPatientPortalFormsEHRReadOnly',
                            this.isNoteReadOnly(arr, 'PPFORMS')
                        );
                        this.$store.commit(
                            'setPatientPortalPrintLetterEHRReadOnly',
                            this.isNoteReadOnly(arr, 'PPLETTER')
                        );
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        setAllPermissions(value) {
            this.$store.commit('setUsePreScreening', value);
            this.$store.commit('setUsePatientLabels', value);
            this.$store.commit('setUseLetters', value);
            this.$store.commit('setUseMars', value);
            this.$store.commit('setUsePatientInfo', value);
            this.$store.commit('setUsePatientInsurance', value);
            this.$store.commit('setUsePatientContact', value);
            this.$store.commit('setUseASAM', value);
            this.$store.commit('setUseClinicalNotes', value);
            this.$store.commit('setUseVitalSign', value);
            this.$store.commit('setUsePatientAllergies', value);
            this.$store.commit('setUsePatientSpecialPr', value);
            this.$store.commit('setUsePatientMarsAlert', value);
            this.$store.commit('setUsePatientAdmission', value);
            this.$store.commit('setUseChartReview', value);
            this.$store.commit('setUseTransfer', value);
            this.$store.commit('setUseDischarge', value);
            this.$store.commit('setUsePatientDiagnosis', value);
            this.$store.commit('setUsePatientDocument', value);
            this.$store.commit('setDailyNotes', value);
            this.$store.commit('setLogNotes', value);
            this.$store.commit('setUseEPharmacyNewCrop', value);
            this.$store.commit('setUseMedications', value);
            this.$store.commit('setCompleteDraft', value);
            this.$store.commit('setAppointments', value);
            this.$store.commit('setSchedulerClinical', value);
            this.$store.commit('setTreatmentPlanClinical', value);
            this.$store.commit('setUsePatientAlerts', value);
            this.$store.commit('setUsePatientActivities', value);
            this.$store.commit('setUsePatientClaims', value);
            this.$store.commit('SetPhysiciansOrder', value);
            this.$store.commit('setUseDrugInboxFill', value);
            this.$store.commit('setUseDrugInboxAllergies', value);
            this.$store.commit('setUseDrugInboxFormularyStatus', value);
            this.$store.commit('setUseDrugInboxPatientSignature', value);
            this.$store.commit('setUseDrugInboxUndoPatientSignature', value);
            this.$store.commit('setUseDrugInboxDrugInfo', value);
            this.$store.commit('setUseDrugInboxPatientInfo', value);
            this.$store.commit('setUseDrugInboxPharmacyNotes', value);
            this.$store.commit('setUseDrugInboxPrescription', value);
            this.$store.commit('setUseDrugInboxPrintMedLabel', value);
            this.$store.commit('setUseDrugInboxPrintMedicationHistory', value);
            this.$store.commit('setUseDrugInboxReturnedItems', value);
            this.$store.commit('setUseDrugInboxSetToChargeable', value);
            this.$store.commit('setUseDrugInboxSetToPending', value);
            this.$store.commit('setUseDrugInboxSetToUnableToFill', value);
            this.$store.commit('setUseDrugInboxSetToValid', value);
            this.$store.commit('setUseDrugInboxUndoFillOrder', value);
            this.$store.commit('setUseDrugInboxUndoSetToChargeable', value);
            this.$store.commit('setUseDrugInboxUndoSetToPending', value);
            this.$store.commit('setUseDrugInboxUndoValidated', value);
            this.$store.commit('setUseTestResult', value);
            this.$store.commit('setUseLab', value);
            this.$store.commit('setTestOrders', value);
            this.$store.commit('setTestResults', value);
            this.$store.commit('setPatientPortalMessage', value);
            this.$store.commit('setPatientPortalContacts', value);
            this.$store.commit('setPatientPortalClaims', value);
            this.$store.commit('setPatientPortalChangeInformation', value);
            this.$store.commit('setPatientPortalChangePassword', value);
            this.$store.commit('setPatientPortalChangeUsername', value);
            this.$store.commit('setPatientPortalCreateCredentials', value);
            this.$store.commit('setPatientPortalEmailTo', value);
            this.$store.commit('setPatientPortalTextTo', value);
            this.$store.commit('setPatientPortalForms', value);
            this.$store.commit('setPatientPortalPrintLetter', value);
        },

        setAllReadOnly(value) {
            this.$store.commit('setLettersEHRReadOnly', value);
            this.$store.commit('setASAMEHRReadOnly', value);
            this.$store.commit('setPatientInfoEHRReadOnly', value);
            this.$store.commit('setPatientInsuranceEHRReadOnly', value);
            this.$store.commit('setPatientContactsEHRReadOnly', value);
            this.$store.commit('setClinicalNotesEHRReadOnly', value);
            this.$store.commit('setVitalSignEHRReadOnly', value);
            this.$store.commit('setPatientAllergiesEHRReadOnly', value);
            this.$store.commit('setPatientSpecialPrEHRReadOnly', value);
            this.$store.commit('setPatientMarsAlertEHRReadOnly', value);
            this.$store.commit('setPatientAdmissionEHRReadOnly', value);
            this.$store.commit('setClinicalTransferEHRReadOnly', value);
            this.$store.commit('setClinicalMedicationsEHRReadOnly', value);
            this.$store.commit('setClinicalDischargeEHRReadOnly', value);
            this.$store.commit('setPatientDiagnosisEHRReadOnly', value);
            this.$store.commit('setPatientDocumentEHRReadOnly', value);
            this.$store.commit('setSchedulerClinicalEHRReadOnly', value);
            this.$store.commit('setAppointmentsEHRReadOnly', value);
            this.$store.commit('setTreatmentPlanEHRReadOnly', value);
            this.$store.commit('setEPrescribingEHRReadOnly', value);
            this.$store.commit('setMarsEHRReadOnly', value);
            this.$store.commit('setTarsEHRReadOnly', value);
            this.$store.commit('setPatientAlertsEHRReadOnly', value);
            this.$store.commit('setPatientActivitiesEHRReadOnly', value);
            this.$store.commit('setPatientClaimsEHRReadOnly', value);
            this.$store.commit('setPhysiciansOrderEHRReadOnly', value);
            this.$store.commit('setDrugInboxFillEHRReadOnly', value);
            this.$store.commit('setDrugInboxAllergiesEHRReadOnly', value);
            this.$store.commit('setDrugInboxFormularyStatusEHRReadOnly', value);
            this.$store.commit('setDrugInboxDrugInfoEHRReadOnly', value);
            this.$store.commit('setDrugInboxPatientInfoEHRReadOnly', value);
            this.$store.commit('setDrugInboxPharmacyNotesEHRReadOnly', value);
            this.$store.commit('setDrugInboxPrescriptionEHRReadOnly', value);
            this.$store.commit('setDrugInboxPrintMedLabelEHRReadOnly', value);
            this.$store.commit('setDrugInboxPrintMedicationHistoryEHRReadOnly', value);
            this.$store.commit('setDrugInboxReturnedItemsEHRReadOnly', value);
            this.$store.commit('setDrugInboxSetToChargeableEHRReadOnly', value);
            this.$store.commit('setDrugInboxSetToPendingEHRReadOnly', value);
            this.$store.commit('setDrugInboxSetToUnableToFillEHRReadOnly', value);
            this.$store.commit('setDrugInboxSetToValidEHRReadOnly', value);
            this.$store.commit('setDrugInboxUndoFillOrderEHRReadOnly', value);
            this.$store.commit('setDrugInboxUndoSetToChargeableEHRReadOnly', value);
            this.$store.commit('setDrugInboxUndoSetToPendingEHRReadOnly', value);
            this.$store.commit('setDrugInboxUndoValidatedEHRReadOnly', value);
            this.$store.commit('setTestOrdersEHRReadOnly', value);
            this.$store.commit('setTestResultsEHRReadOnly', value);

            this.$store.commit('setPatientPortalMessageEHRReadOnly', value);
            this.$store.commit('setPatientPortalContactsEHRReadOnly', value);
            this.$store.commit('setPatientPortalClaimsEHRReadOnly', value);
            this.$store.commit('setPatientPortalChangeInformationEHRReadOnly', value);
            this.$store.commit('setPatientPortalChangePasswordEHRReadOnly', value);
            this.$store.commit('setPatientPortalChangeUsernameEHRReadOnly', value);
            this.$store.commit('setPatientPortalCreateCredentialsEHRReadOnly', value);
            this.$store.commit('setPatientPortalEmailToEHRReadOnly', value);
            this.$store.commit('setPatientPortalTextToEHRReadOnly', value);
            this.$store.commit('setPatientPortalFormsEHRReadOnly', value);
            this.$store.commit('setPatientPortalPrintLetterEHRReadOnly', value);
        },

        isNoteReadOnly(arr, noteId) {
            const permission = arr.find(data => data.notesid === noteId);
            if (permission) {
                return permission.readOnly;
            }

            return false;
        },

        getEHRFeaturePermission(arr, noteId) {
            const permission = arr.find(data => data.notesid === noteId);
            if (permission) {
                return permission.checked;
            }

            return true;
        }
    }
};
